<template>

  <data-form
    :entity="controller"
    :fields="fields"
    model="controllers"
    :buttons="buttons"
    :cancel="false"
    ignoreEntityChanges
  />

</template>

<script>
import inputTypes from './inputTypes'

export default {
  name: 'controller-form',
  props: {
    controller: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      fields: {
        'name': {
          rules: [{ required: true }, { max: 12 }]
        },
        'description': {
          rules: [{ required: true }, { max: 18 }]
        },
        'input_type': {
          type: 'select',
          options: inputTypes
        },
        'x_pos': { type: 'number' },
        'y_pos': { type: 'number' },
        'z_pos': { type: 'number' }
      },
      buttons: [
        {
          label: 'submit-scheduled',
          submit: true,
          params: {
            scheduled: true
          }
        },
        {
          label: 'submit',
          submit: true,
          params: {
            scheduled: false
          }
        }
      ]
    }
  }
}
</script>


// WEBPACK FOOTER //
// ControllerForm.vue?4102c488